var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"date",attrs:{"title":"Дата и время публикации"}},[_vm._v(_vm._s(_vm.timeConverter(_vm.data)))])}
var staticRenderFns = []

export { render, staticRenderFns }